import { useEffect } from "react";
import Reveal from "@/components/site/Reveal";
import SectionLabel from "@/components/site/SectionLabel";
import FAQSection from "@/components/sections/FAQSection";
import CTASection from "@/components/sections/CTASection";

export default function FAQ() {
    useEffect(() => {
        document.title = "FAQ | 90 Day Alpha";
    }, []);
    return (
        <div data-testid="faq-page" className="bg-[#020617]">
            <section className="pt-40 pb-12 md:pt-48 md:pb-16">
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <Reveal>
                        <SectionLabel testId="faq-page-label">
                            Frequently Asked
                        </SectionLabel>
                        <h1 className="mt-6 font-display font-black text-white text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.98] max-w-4xl">
                            Get the{" "}
                            <span className="text-[#D4AF37]">answers</span>{" "}
                            before you apply.
                        </h1>
                    </Reveal>
                </div>
            </section>
            <FAQSection />
            <CTASection />
        </div>
    );
}
